import React from "react";
import { FormikField } from "components/generic/FormikField";

type Props = {
    name: string;
    label?: string;
    type?: "text" | "number" | "email";
    as?: "textarea";
    maxLength?: number;
    placeholder?: string;
    inputClassName?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    readOnly?: "readonly";
};

// A form row component designed to work as part of a Formik form.
export const FormikFormRow: React.FC<Props> = (props: Props) => {
    return (
        <div className="row input-row">
            <div className="col-sm-12">
                <FormikField {...props} inputClassName={props.inputClassName ?? "large-input "} />
            </div>
        </div>
    );
};
